
export default function encodeQueryParams(params) {
  return Object.keys(params).map(function(key) {
    return [key, params[key]].map(encodeURIComponent).join('=');
  }).join('&');
}
